import {Component, OnInit} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {debounceTime, map, publishReplay, refCount} from 'rxjs/operators';
import {AppHomeScreenInstallerService, TicketInsuranceMandateRequestsHelperService} from '@lifeislife/lifeislife-components';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ShellBannerDesc} from './shell-banner-desc';
import {ShellBannerService} from '../../service/shell-banner-service';
import {ShellBannerActionDesc} from './shell-banner-action-desc';

@Component({
  selector: 'cf-shell-banners',
  templateUrl: './shell-banners.component.html',
  styleUrls: ['./shell-banners.component.scss'],
  providers: [
    TicketInsuranceMandateRequestsHelperService,
  ],
  animations: [
    trigger('bannerIn', [
      state('in', style({
        height: 'auto',
      })),
      transition(':enter', [
        style({height: '0'}),
        animate(100),
      ]),
      transition(':leave', [
        animate(100),
        style({height: '0'}),
      ]),
    ]),
  ],
})
export class ShellBannersComponent implements OnInit {

  activeBanner$: Observable<ShellBannerDesc | null>;

  constructor(
    private shellBannerService: ShellBannerService,
    private appHomeScreenInstallerService: AppHomeScreenInstallerService,
  ) {
  }

  ngOnInit(): void {
    this.activeBanner$ = combineLatest([
      this.shellBannerService.firstBanner$,
      this.shellBannerService.bannersVisible$,
    ]).pipe(
      debounceTime(200),
      map(r => r[1] ? r[0] : null),
      publishReplay(1), refCount(),
    );
  }

  onAppInstallConfirm() {
    this.appHomeScreenInstallerService.askInstallToHomeScreen();
  }

  onAppInstallCancel() {
    this.appHomeScreenInstallerService.discardAppInstall();
  }

  fireAction(action: ShellBannerActionDesc, event: Event) {
    action.callback();
    if (action.clearMessage) {
      this.shellBannerService.clearFirstBanner();
    }
  }
}
